var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgShare = function SvgShare(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 19C7 20.6568 5.65685 22 4 22C2.34315 22 1 20.6568 1 19C1 17.3431 2.34315 16 4 16C4.35064 16 4.68722 16.0601 5 16.1707M7 19C7 17.6938 6.16519 16.5825 5 16.1707M7 19H17M5 16.1707L10 7.23999",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5C15 5.8885 14.6137 6.68679 14 7.23611C13.4692 7.71115 12.7684 8 12 8C11.2316 8 10.5308 7.71115 10 7.23611C9.38625 6.68679 9 5.8885 9 5C9 3.34315 10.3431 2 12 2C13.6569 2 15 3.34315 15 5Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16.1707C17.8348 16.5825 17 17.6938 17 19C17 20.6568 18.3431 22 20 22C21.6569 22 23 20.6568 23 19C23 17.3431 21.6569 16 20 16C19.6494 16 19.3128 16.0601 19 16.1707ZM19 16.1707L14 7.23999",
    stroke: "currentColor",
    strokeWidth: 2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share.fc303de3bbc73d2515b9faecb8e7c5ae.svg";